'use client';

// base
import React from 'react';
import dynamic from 'next/dynamic';

// styles
import { StyledSplashLoader } from './style';

// jsons
import loadingAnimations from './circle-loading.json';

// libraries
import { type LottieProps } from 'react-lottie';
const Lottie = dynamic(() => import('react-lottie'), { ssr: false });

interface SplashLoaderProps extends Omit<LottieProps, 'options'> {
  bgColor?: string;
  onSegmentStart?: () => void;
  onCompleted?: () => void;
}

export const SplashLoader: React.FC<SplashLoaderProps> = ({
  bgColor = '#ffffff7a',
  onSegmentStart,
  onCompleted,
  ...props
}) => {
  const handleSegmentStart = () => {
    onSegmentStart?.();
  };

  const handleComplete = () => {
    onCompleted?.();
  };

  return (
    <StyledSplashLoader $bgColor={bgColor}>
      <Lottie
        style={{ transform: 'scale(0.16)' }}
        isClickToPauseDisabled
        eventListeners={[
          {
            eventName: 'segmentStart',
            callback: handleSegmentStart
          },
          {
            eventName: 'complete',
            callback: handleComplete
          }
        ]}
        {...props}
        options={{
          loop: true,
          autoplay: true,
          animationData: loadingAnimations,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
          }
        }}
      />
    </StyledSplashLoader>
  );
};
